export default defineNuxtPlugin((nuxtApp) => {
    const allowedDomains = [
        "thorne.com",
    ]

    const allowedForwardedHeaders = [
        "cookie",
        "user-agent",
        "accept-language",
        "referer",
        "x-forwarded-for",
        "x-real-ip",
        "x-datadog-trace-id",
        "x-datadog-parent-id",
        "x-datadog-sampling-priority",
        "x-datadog-tags"
    ]

    const runtimeConfig = useRuntimeConfig()
    const requestDomain = useRequestURL().origin
    const defaultDomain = runtimeConfig.public.thorneSite ?? 'https://www.thorne.com'
    const hasMatch = !requestDomain.includes("nuxt") && !!allowedDomains.findLast(tld => requestDomain.toLowerCase().endsWith(tld.toLowerCase()))

    // forward client headers as they aren't by default if it's an server/SSR fetch due to the domain being explicitly set (i.e. not an internal api route)
    // all client/CSR fetches will forward headers by default
    const requestHeaders = useRequestHeaders() ?? {}; // useRequestHeaders is empty on the client
    const filteredHeaders = Object.fromEntries(Object.entries(requestHeaders).filter(([key]) => allowedForwardedHeaders.includes(key)));

    const requestEvent = useRequestEvent();

    const siteFetch = $fetch.create({
        baseURL: hasMatch ? requestDomain : defaultDomain,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-Nuxt-Request-From': import.meta.server ? "server" : "client",
            ...filteredHeaders
        },
        onResponse: async ({ response }) => {
            // parse set-cookie header and set cookies on the request event
            // this is needed for server/SSR fetches as the cookies are not set by default
            if (!!requestEvent) {
                const setCookieHeader = response.headers.getSetCookie();
                if (!!setCookieHeader) {
                    const existingSetCookieHeader = requestEvent.node.res.getHeader('Set-Cookie');
                    if (!!existingSetCookieHeader) {
                        if (Array.isArray(existingSetCookieHeader)) {
                            setCookieHeader.push(...existingSetCookieHeader);
                        }
                        else {
                            setCookieHeader.push(existingSetCookieHeader.toString());
                        }
                    }
                    requestEvent.node.res.setHeader('Set-Cookie', setCookieHeader);
                }
            }
        }
    });
    // Expose to useNuxtApp().$siteFetch
    return {
        provide: {
            siteFetch
        }
    }
})